<div class="re-dialog">
  <div class="re-header">
    <div class="re-title-wrap">
      <div class="re-title-icon"><mat-icon>event_repeat</mat-icon></div>
      <div><h2 class="re-title">{{type}} recurring event</h2><div class="re-subtitle">Choose how much of the series to change</div></div>
    </div>
    <button mat-icon-button mat-dialog-close class="re-close" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <div class="re-body">
    <mat-radio-group aria-label="Recurring event scope" class="re-options" [(ngModel)]="choice">
      <label class="re-option" [class.on]="choice === 'one'">
        <mat-radio-button value="one"></mat-radio-button>
        <span><strong>This event</strong><small>Only the event on this date</small></span>
      </label>
      <label class="re-option" [class.on]="choice === 'following'">
        <mat-radio-button value="following"></mat-radio-button>
        <span><strong>This and following events</strong><small>This event and every later event in the series</small></span>
      </label>
      <label class="re-option" [class.on]="choice === 'all'">
        <mat-radio-button value="all"></mat-radio-button>
        <span><strong>All events</strong><small>The complete recurring series</small></span>
      </label>
    </mat-radio-group>
  </div>
  <div class="re-footer">
    <button mat-button mat-dialog-close class="re-btn-ghost">Cancel</button>
    <button type="button" class="re-btn-primary" (click)="save()"><span>Continue</span><mat-icon>arrow_forward</mat-icon></button>
  </div>
</div>
